import React from "react"
import Navbar from "../../../Common/Navbar"
import Footer from "../../../Common/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import ContactParentComp from "./Component/ContactParentComp"


const ContactParent =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <ContactParentComp />
        </div>
        <Footer />
        </>
    )
}

export default ContactParent